

const spacers = {
  M: '8px',
  S: '4px',
  L: '16px',
  XL: '24px',
  XXL: '32px' };


export default spacers;